import { BsThreeDots } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-responsive-carousel';

import { CardLesson } from 'components';
import { NextLessonsInterface, Banner } from 'types';
import { useBasic } from 'contexts';

import { BannerSlide } from './BannerSlide';

import './style.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import noLessons from 'assets/images/home-no-lessons.jpg';

const BANNER_LINK_CLASS = 'block w-full h-auto no-underline p-0 m-0';
const BANNER_IMAGE_CLASS = 'block w-full h-auto p-0 m-0 max-h-[200px] sm:max-h-[300px] lg:max-h-[400px] object-cover mx-auto';
const CAROUSEL_IMAGE_CLASS = 'block w-full h-[200px] sm:h-[300px] lg:h-[400px] object-cover';

export type BoxNextLessonsProps = {
  lessons: NextLessonsInterface[];
  title?: string;
  maxLength?: number;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  banners?: Banner[];
  [key: string]: any;
};

export function BoxNextLessons({ lessons, title, maxLength, children, className, style, banners, ...rest }: BoxNextLessonsProps) {
  const { appearance } = useBasic();

  return (
    <section className={`box-next-lessons ${className || ''}`} style={style} {...rest}>
      {!!title?.length && (
        <div className="box-next-lessons__head flex justify-between items-center mb-3 lg:mb-7">
          <h2 className="font-medium">{title}</h2>

          <div className="box-next-lessons__actions hidden lg:block">
            {!!lessons.length && (
              <button>
                <BsThreeDots />
              </button>
            )}
          </div>
        </div>
      )}

      {!!lessons.length && (
        <div className={`box-next-lessons__cards block lg:flex justify-between items-stretch lg:-mx-5`}>
          {lessons.slice(0, typeof maxLength === 'number' ? maxLength : lessons.length).map((lesson, index, obj) => (
            <CardLesson key={lesson._id} lesson={lesson} className={`${obj.length > 1 ? 'w-full lg:w-2/4' : 'w-full'} lg:mx-5`} />
          ))}
        </div>
      )}

      {!lessons.length && (
        <div id="banner" className={`box-next-lessons__cards block lg:flex justify-between items-stretch `}>
          {banners && banners.length > 1 ? (
            <Carousel
              autoPlay
              interval={(appearance?.bannerHome.time || 5) * 1000}
              infiniteLoop
              showStatus={false}
              showThumbs={false}
              showArrows={appearance?.bannerHome.showArrows || false}
              showIndicators={appearance?.bannerHome.showIndicators || false}
              className="banner-carousel w-full"
            >
              {banners.map(banner => (
                <BannerSlide key={banner._id} banner={banner} className={BANNER_LINK_CLASS} imageClassName={CAROUSEL_IMAGE_CLASS} />
              ))}
            </Carousel>
          ) : banners && banners.length === 1 ? (
            <BannerSlide banner={banners[0]} className={BANNER_LINK_CLASS} imageClassName={BANNER_IMAGE_CLASS} />
          ) : (
            <Link to={'/cursos'} className={BANNER_LINK_CLASS}>
              <img src={noLessons} alt={title || ''} className={BANNER_IMAGE_CLASS} />
            </Link>
          )}
        </div>
      )}

      {children}
    </section>
  );
}
